import { TetherDialog } from './../../../common-module/modules/tether-dialog/tether-dialog';
import { Component, OnInit, Input, HostBinding, state } from '@angular/core';

@Component({
  selector: 'app-installment-options',
  templateUrl: './installment-options.component.html',
  styleUrls: ['./installment-options.component.scss']
})
export class InstallmentOptionsComponent implements OnInit {
  @HostBinding('class.c-installment-options') true;
  @Input() installmentOptions;
  @Input() state;
  
  selectedData:{bkmCode:string,installmentCount:number, rate:number, installmentAmount: number, totalAmount:number};
  

  constructor( public tether: TetherDialog) { }

  ngOnInit() {

  }

  pushInstallment() {
    this.tether.close(this.selectedData);
  }
  
  installmentsChangeAction(installmentCount,bankBkmCode,installmentRate, installmentAmount, totalAmount) {

    this.selectedData = {
      bkmCode:bankBkmCode,
      rate: installmentRate,
      installmentCount:installmentCount,
      installmentAmount:installmentAmount,
      totalAmount: totalAmount
    }
  }

  close() {
    this.tether.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/boxoffice-module/components/installment-options/installment-options.component.ts